import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranscribeService} from "../shared/transcribe.service";
import {TranscribeLanguage} from "../shared/TranscribeLanguage";
import {TranscribeJob} from "../shared/TranscribeJob";
import {Storyboard} from "storyboard-renderer";
import {TranslateService} from "../shared/translate.service";
import {TranslationLanguage} from "../shared/TranslationLanguage";

@Component({
  selector: 'app-transcribe',
  templateUrl: './transcribe.component.html',
  styleUrls: ['./transcribe.component.scss']
})
export class TranscribeComponent implements OnInit {

  @Input() storyboard: Storyboard;

  transcribeLanguage = "en-GB";
  targetLanguage = "no-translation";
  languages = [];
  targetLanguages = [];

  indicators = {
    generating: false,
    loadingLanguages: false,
    loadingTargetLanguages: false,
    progress: 0
  };

  timeout;
  requestTimeout = 2000;

  constructor(public activeModal: NgbActiveModal, public transcribeService: TranscribeService, public translateService: TranslateService) { }

  ngOnInit() {
    this.indicators.loadingLanguages = true;
    this.indicators.loadingTargetLanguages = true;

    this.transcribeService.getLanguages(this.storyboard).then((languages: TranscribeLanguage[]) => {
      this.languages = languages;
      this.indicators.loadingLanguages = false;
    }).catch(error =>{
      this.indicators.loadingLanguages = false;
    });

    this.translateService.getLanguages(this.storyboard).then((languages: TranslationLanguage[]) => {
      this.targetLanguages = languages;
      this.indicators.loadingTargetLanguages = false;
    }).catch(error =>{
      this.indicators.loadingTargetLanguages = false;
    });
  }

  cancelProgress(reason) {
    clearTimeout(this.timeout);
    this.activeModal.dismiss(reason);
  }

  private generateAudioTranscription() {
    this.indicators.generating = true;

    this.transcribeService.create(this.storyboard, this.transcribeLanguage, this.targetLanguage).then((result: TranscribeJob) => {
      this.storyboard.transcribe_job_id = result.id;

      // It was already done before and readed from cache
      if(result.status === TranscribeJob.DONE) {

        this.indicators.generating = false;
        this.activeModal.close(result.transcription);

      } else {

        this.timeout = setTimeout(() => {
          this.startChecking();
        }, this.requestTimeout);

      }

    }).catch(error => {
      this.indicators.generating = false;
    });
  }

  private startChecking() {
    this.transcribeService.getTranscribeJob(this.storyboard).then((job: TranscribeJob) => {
      switch(job.status) {
        case TranscribeJob.NOT_CONSUMED:
        case TranscribeJob.PROCESSING:
          this.timeout = setTimeout(() => { this.startChecking(); }, this.requestTimeout);
          this.indicators.progress = Math.round(job.estimatedProgress);
          break;

        case TranscribeJob.DONE:
          this.indicators.generating = false;
          this.activeModal.close(job.transcription);
          break;

        case TranscribeJob.FAILED:
          this.indicators.generating = false;
          this.cancelProgress({error: 'job_failed'});
          break;

        default:
          this.indicators.generating = false;
          this.cancelProgress({error: 'wrong_status'});
          break;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/transcribe/transcribe.component.ts